import { axios, fileAxios } from '../../../plugins/axios'

export default {
  namespaced: true,

  state: {
    evaluacionMedica: [],
  },

  getters: {
    getEvaluacionMedica: (state) => {
      return state.evaluacionMedica
    },
  },

  mutations: {
    SET_EVALUACION_MEDICA(state, evaluacionMedica) {
      state.evaluacionMedica = evaluacionMedica
    },
  },

  actions: {
    fetchEvaluacionMedicaByPersonal: async function ({ commit }, idPersonal) {
      try {
        const response = await axios.get('/PoliciaCuadrantes/EstadoFuerza/personal/' + idPersonal + '/evaluacionMedica')
        commit('SET_EVALUACION_MEDICA', response.data.data)
      } catch (error) {
        console.log(error)
      }
    },

    saveEvaluacionMedica: async function (context, evaluacionMedica) {
      try {
        const response = await axios.post(
          '/EonCloud/EstadoFuerza/personal/' + evaluacionMedica.fk_idPersonal + '/evaluacionMedica',
          evaluacionMedica
        )
        context.commit('SET_SNACKBAR_MESSAGE', 'Evaluación médica agendada correctamente.', {
          root: true,
        })
        return response
      } catch (error) {
        console.log(error)
        context.commit(
          'SET_SNACKBAR_MESSAGE',
          'Error al agendar la evaluación médica. Por favor, intente nuevamente.',
          { root: true }
        )
        throw error
      }
    },

    updateEvaluacionMedica: async function (context, evaluacionMedica) {
      try {
        // Primero actualizar los datos de la evaluación
        const response = await axios.put(
          '/EonCloud/EstadoFuerza/personal/' +
            evaluacionMedica.fk_idPersonal +
            '/evaluacionMedica/' +
            evaluacionMedica.idEvaluacionMedica,
          evaluacionMedica
        )

        console.log(response.data.data)

        // Intentar subir archivo si hay uno
        if (evaluacionMedica.file) {
          var formData = new FormData()
          formData.append('file', evaluacionMedica.file)
          formData.append('idEvaluacionMedica', evaluacionMedica.idEvaluacionMedica)
          formData.append('fk_idPersonal', evaluacionMedica.fk_idPersonal)
          console.log(formData)

          // Intentar subir el archivo - si falla, lanzar error
          await context.dispatch('uploadEvaluacionMedica', formData)
        } else {
          // Si no hay archivo, mostrar éxito directamente
          context.commit('SET_SNACKBAR_MESSAGE', 'Evaluación médica registrada correctamente.', {
            root: true,
          })
        }

        return response
      } catch (error) {
        console.log(error)
        context.commit('SET_SNACKBAR_MESSAGE', 'Ocurrió un problema al registrar la evaluación médica.', { root: true })
        throw error
      }
    },

    uploadEvaluacionMedica: async function (context, formData) {
      // Intentar múltiples endpoints posibles
      const endpoints = [
        '/SetAdjuntoEvaluacionMedica/uploadFiles',
        '/EvaluacionMedica/uploadFiles',
        '/PoliciaCuadrantes/EstadoFuerza/evaluacionMedica/uploadFiles',
      ]

      let lastError = null

      for (const endpoint of endpoints) {
        try {
          const response = await fileAxios.post(endpoint, formData)
          context.commit('SET_SNACKBAR_MESSAGE', 'Evaluación médica registrada correctamente.', {
            root: true,
          })
          return response
        } catch (error) {
          lastError = error
          console.log(`Intento con ${endpoint} falló:`, error.response?.status)
          // Continuar intentando con el siguiente endpoint
        }
      }

      // Si todos los intentos fallaron, lanzar error sin mostrar mensaje aquí
      // El mensaje lo mostrará updateEvaluacionMedica
      console.log('Todos los endpoints de upload fallaron')
      throw lastError
    },
  },
}
